import React from 'react';
import { committeeExperience, governanceMilestones } from '../data/governance';
export function GovernanceOversight() {
  return <div className="grid gap-12 lg:grid-cols-12" data-id="element-139" data-mp="162xtod60n71y">
      <div className="lg:col-span-5" data-id="element-140" data-mp="r6ffcj2mc6ym">
        <div className="space-y-5 text-[1.05rem] leading-[1.8] text-charcoal" data-id="element-141" data-mp="r5du5lrw2436">
          <p data-id="element-142" data-mp="w4gyt53yi8am">
            Beyond normal board duties, Jim has chaired audit, remuneration, nomination and pension fund committees,
            and has implemented corporate governance procedures in organisations moving from founder-led or statutory
            structures to modern board practice.
          </p>
          <p data-id="element-143" data-mp="8gqszecu1yuv">
            In the public sector he has provided audit and risk oversight at the Rural Payments Agency and BBSRC. In
            international research, he has twice been at the centre of system-wide governance reform across the CGIAR.
          </p>
        </div>
        <div className="mt-8" data-id="element-144" data-mp="3h4b2rm27ufq">
          <p className="text-sm font-medium text-charcoal-muted" data-id="element-145" data-mp="3g30eo8yh9yj">Committees chaired or served on</p>
          <ul className="mt-3 flex flex-wrap gap-2" data-id="element-146" data-mp="22v16fr1pgqza">
            {committeeExperience.map(c => <li key={c} className="whitespace-nowrap rounded-full border border-forest/30 px-3.5 py-1 text-sm text-forest" data-id="element-147" data-mp="1xwzmz50dapna">
                {c}
              </li>)}
          </ul>
        </div>
      </div>

      <ol className="lg:col-span-7" data-id="element-148" data-mp="27tm7ttsp1gpb">
        {governanceMilestones.map(m => <li key={m.title} className="grid grid-cols-[5.5rem_1fr] gap-5 border-t border-rule py-5 last:border-b" data-id="element-149" data-mp="1k6me90fnj6ww">
            <p className="font-serif text-lg tabular-nums text-wheat-dark" data-id="element-150" data-mp="1f4x55qbzp3bg">{m.year}</p>
            <div data-id="element-151" data-mp="1tx8pkigc5b9s">
              <h3 className="font-serif text-lg text-forest" data-id="element-152" data-mp="1txqwc90mj7vy">{m.title}</h3>
              <p className="mt-1 text-sm leading-relaxed text-charcoal" data-id="element-153" data-mp="1p3mkbbci49o0">{m.text}</p>
            </div>
          </li>)}
      </ol>
    </div>;
}